export default function AppConfig() {
	if ( process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'  ) {
		// values are: 'development', 'test', 'production'.
		return {
			debug: true,
			wpVersion: '5.8.2',
			version: '2.0.0',			
			mode: process.env.NODE_ENV,
			homeUrl: 'http://www.dev-wpg.com',
			namespace: 'wpglobus-to/v1',
			route: 'options',
			apiBaseUrl: 'http://www.dev-wpg.com/wp-json/wpglobus-to/v1/options/',
			endPointByDefault: 'translateit',
			endPoints: { 
				themeOptions: {
					route: 'themeOptions',
					tableName: 'themeOptions',
					options: {
						itemsPerPage: 2,					
						tablePageSize: 5,					
					}							
				},
				optionsToTranslate: {
					route: 'totranslate',
					tableName: 'optionsToTranslate',				
					options: {
						itemsPerPage: 'optionsToTranslateTableItemsPerPage',					
					}					
				},
				allOptions: {
					route:'',
					readable_callback:'get_items',
					tableName: 'allOptions',
					options: {
						itemsPerPage: 'allOptionsTableItemsPerPage',					
					}						
				},
				getAboutInfo: {
					route:'about',
					readable_callback:'get_about_info'
				},
				getMasks: {
					route:'masks',
					readable_callback:'get_mask_items',
					editable_callback:'update_masks'
				},
				updateMasks: {
					route:'masks',
					readable_callback:'get_mask_items',
					editable_callback:'update_masks'
				},
				getRaw: {
					route:'raw',
					readable_callback:'get_raw',
				},
				updateItemsPerPage: {
					route:'itemsperpage',
					readable_callback:'get_option_items_per_page',
					editable_callback:'update_option_items_per_page'				
				},
				switchInterface: {
					route:'switchInterface',
					readable_callback:'get_option_interface_version',
					editable_callback:'update_option_interface_version'				
				},
				getOption: {
					route:'/S+/', // '/\S+/'
					// route:'getOptionValue',
					readable_callback:'get_option_value',
				}
			},
			defaultLanguage: 'en',
			enabledLanguages: [	'en', 'ru', 'fr' ],
			enLanguageName: { en:'English', ru:'Russian', fr:'French' },
			// tablePageSize:'15',
			defaultTablePageSize:'15',
			allOptionsTableItemsPerPage: '9',
			optionsToTranslateTableItemsPerPage: '10',
			interfaceVersion: '2'
		}
	} else {
		if ( 'string' === typeof window.WPGlobusTranslateOptions.debug ) {
			window.WPGlobusTranslateOptions.debug = !(/^(false|0)$/i).test(window.WPGlobusTranslateOptions.debug) && !!window.WPGlobusTranslateOptions.debug
		}
		return window.WPGlobusTranslateOptions;
	}	
}
